import { prefersReducedMotion } from './preferences.js';
const defaultAnimationRegistry = new Map();
const customAnimationRegistry = new WeakMap();
function ensureAnimation(animation) {
    if (!animation) {
        return { keyframes: [], options: { duration: 0 } };
    }
    return animation;
}
function setDefaultAnimation(animationName, animation) {
    defaultAnimationRegistry.set(animationName, ensureAnimation(animation));
}
function setAnimation(el, animationName, animation) {
    customAnimationRegistry.set(el, { ...customAnimationRegistry.get(el), [animationName]: ensureAnimation(animation) });
}
function getAnimation(el, animationName) {
    const customAnimation = customAnimationRegistry.get(el);
    if (customAnimation && customAnimation[animationName]) {
        return customAnimation[animationName];
    }
    const defaultAnimation = defaultAnimationRegistry.get(animationName);
    if (defaultAnimation) {
        return defaultAnimation;
    }
    return { keyframes: [], options: { duration: 0 } };
}
function startAnimations(el, keyframes, options) {
    return new Promise(resolve => {
        if ((options === null || options === void 0 ? void 0 : options.duration) === Infinity) {
            throw new Error('Promise-based animations must be finite.');
        }
        const animation = el.animate(keyframes, {
            ...options,
            duration: prefersReducedMotion() ? 0 : options.duration,
        });
        animation.addEventListener('cancel', resolve, { once: true });
        animation.addEventListener('finish', resolve, { once: true });
    });
}
function stopAnimations(el) {
    return Promise.all(el.getAnimations().map(animation => new Promise(resolve => {
        const handleAnimationEvent = requestAnimationFrame(resolve);
        animation.addEventListener('cancel', () => handleAnimationEvent, { once: true });
        animation.cancel();
    })));
}
function parseDuration(delay) {
    const delayStr = delay.toString().toLowerCase();
    if (delayStr.indexOf('ms') > -1) {
        return parseFloat(delayStr);
    }
    if (delayStr.indexOf('s') > -1) {
        return parseFloat(delayStr) * 1000;
    }
    return parseFloat(delayStr);
}
function shimKeyframesHeightAuto(keyframes, calculatedHeight) {
    return keyframes.map(keyframe => ({
        ...keyframe,
        height: keyframe.height === 'auto' ? `${calculatedHeight}px` : keyframe.height,
    }));
}
export { setDefaultAnimation, setAnimation, getAnimation, startAnimations, stopAnimations, parseDuration, shimKeyframesHeightAuto, };
